import 'antd/dist/antd.css'

import ReactDOM from 'react-dom'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import Cookie from 'js-cookie'
import App from './App'
import Login from './pages/login/login'
import reportWebVitals from './reportWebVitals'

// 登录凭证
let token = Cookie.get('token')
let isLogin: Boolean = token !== undefined && token.length > 0
let RenderApp: Function = isLogin ? App : Login

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <RenderApp />
  </ConfigProvider>,

  document.getElementById('root')
)

reportWebVitals()